"use client";
import { Fragment } from "react";
import { ControlsYearType } from "@/utils/types";
import { useAppStore } from "@/store/app";
import { useDataStore } from "@/store/data";
import { cn, getValue } from "@/utils/helpers";
import { getControlStats, getLang, getYearsOfStat } from "@/utils/selectors";
import Tooltip from "@/components/common/Tooltip";
import Skeleton from "@/components/common/Skeleton";
import styles from "../Profile.module.css";

export default function ProfileTempExp() {
	const controls = useAppStore(store => store.controls);
	const selectedLocation = useAppStore(store => store.selectedLocation);
	const dataLoading = useDataStore(store => store.dataLoading);

	return (
		<div
			className={styles.ProfileTempExp}
		>
			{getControlStats(controls.view, "exp").map((stat: string, index: number) =>
				<div
					key={index}
					className={styles.ProfileStat}
				>
					<hgroup
						className={styles.ProfileStatHeading}
					>
						<h4
							className={styles.ProfileStatTitle}
						>
							{getLang(controls.view, stat, "title")}
						</h4>
						<Tooltip
							hasIcon={true}
							inner={getLang(controls.view, stat, "tooltip")}
							footer={getLang("stat", "tooltip", "footer")}
							className={styles.ProfileStatTitleTooltip}
						/>
						{/* <p
							className={styles.ProfileStatSubtitle}
						>
							{getLang(controls.view, stat, "subtitle")}
						</p> */}
					</hgroup>
					<dl
						className={cn(
							styles.ProfileStatValues,
							styles.ProfileTempStatValues,
							styles.ProfileTempExpStatValues
						)}
					>
						{getYearsOfStat(controls.view, stat).map((year: ControlsYearType, index: number) =>
							<Fragment
								key={index}
							>
								<dt
									className={styles.ProfileStatLabel}
								>
									{getLang("year", year, "short")}
								</dt>
								<dd
									className={styles.ProfileStatValue}
								>
									<Skeleton
										loading={dataLoading}
									>
										{getValue(`${controls.view}_${stat}_${year}`, selectedLocation) ?? "N/A"}
									</Skeleton>
								</dd>
							</Fragment>
						)}
					</dl>
				</div>
			)}
		</div>
	);
}